import { type FC } from "react";

import clsx from "clsx";

import {
  SEGMENTS,
  SEGMENT_COPY,
  type Segment,
  type SegmentPanel,
} from "./segment_copy";

// The .itxt block above each panel (kit: sections/Intelligences.html). Departure
// from the kit: it swapped one paragraph's text per segment, so all four are
// rendered and only the active one shown — AI crawlers never run JS.
export const IntelligencePanelText: FC<{
  who: string;
  verb: string;
  field: SegmentPanel;
  copySegment: Segment;
  fading: boolean;
  washing: boolean;
  onWashEnd: () => void;
}> = ({ who, verb, field, copySegment, fading, washing, onWashEnd }) => (
  <div
    className={clsx("itxt", washing && "washing")}
    onAnimationEnd={onWashEnd}
  >
    <div className="who">{who}</div>
    <div className="verb">{verb}</div>
    {SEGMENTS.map((key) => {
      const active = key === copySegment;

      return (
        <p
          key={key}
          id={active ? `copy-${field}` : undefined}
          className={clsx(active && fading && "copyfade")}
          style={active ? undefined : { display: "none" }}
        >
          {SEGMENT_COPY[key][field]}
        </p>
      );
    })}
  </div>
);
